import { render, staticRenderFns } from "./BannerContent.vue?vue&type=template&id=5d55c899&scoped=true"
import script from "./BannerContent.vue?vue&type=script&lang=js"
export * from "./BannerContent.vue?vue&type=script&lang=js"
import style0 from "./BannerContent.vue?vue&type=style&index=0&id=5d55c899&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d55c899",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/home/luiz/Sistemas/loja/components/Loader.vue').default,LayoutWavesBackgroundBottom: require('/home/luiz/Sistemas/loja/components/Layout/WavesBackgroundBottom.vue').default,DialogStatusPayment: require('/home/luiz/Sistemas/loja/components/DialogStatusPayment.vue').default})
